module.exports = "data:text/x-markdown;base64,IyMge3sgZmllbGQubmFtZSB9fQoKYHt7IGZpZWxkLm5hbWUgfX1gIGlzIGEgc3BlY2lhbCBmaWVsZCBhdXRvbWF0aWNhbGx5IGFkZGVkIGJ5IFtjYXJ0b11bY2FydG9dIHRvCnNwZWVkIHVwIHJlbmRlcmluZyBvZiB0aWxlcyBmb3IgbWFwcGluZyBzZXJ2aWNlcy4gSXQgaXMgdGhlIHNhbWUgYXMgdGhlCmB0aGVfZ2VvbWAgY29sdW1uIGJ1dCBwcm9qZWN0ZWQgaW4gV2ViIE1lcmNhdG9yIChFUFNHOjM4NTcpLgoKW2NhcnRvXTogaHR0cHM6Ly9jYXJ0by5jb20K"


//////////////////
// WEBPACK FOOTER
// ./src/content/the_geom_webmercator.md
// module id = 317
// module chunks = 0